
import React from "react";
import PropTypes from 'prop-types';

import TeamInfo from "./TeamInfo";
import Static from "../../lib/Static";
import style from "./TeamList.css";

const TeamList = ({ teamId, jobs }) => {
  let teamSelection = Static.teams;
  let talentPool = Static.teams.filter((team) => team.name === "Talent Pool")[0];

  if (teamId > -1) {
    teamSelection = [Static.teams[teamId]];
  }

  // remove the talent pool job to allow it to be shown after all other jobs on the page
  let jobsWithoutTalentPool = jobs.filter((job) => job.code !== "Talent Pool");

  return (
    <div className={style.teamList}>
      {teamSelection.map((team, idx) =>
        <TeamInfo
          key={idx}
          team={team}
          jobs={jobsWithoutTalentPool}
        />
      )}
      {talentPool && (<TeamInfo key={talentPool.id} team={talentPool} jobs={jobs} />)}
    </div>
  );
};

TeamList.propTypes = {
  teamId: PropTypes.number.isRequired,
  jobs: PropTypes.array.isRequired
};

export default TeamList;



// WEBPACK FOOTER //
// ./component/TeamList/index.js